<!-- 关联实体 -->
<template>
  <div v-loading="loading">
    <div class="container">
      <div class="containerBox">
        <div class="search">
          <div class="searchBox">
            <span class="searchtitle">企业</span>
            <el-input
              class="vin-input"
              v-model.trim="entpName"
              placeholder="请输入企业名称"
            ></el-input>

            <el-button
              class="btn-primary"
              @click="getEntpData"
              :disabled="isRele"
              icon="el-icon-search"
              >查找企业</el-button
            >
          </div>
        </div>
        <div class="search-result" v-if="!isNonResult">
          <el-table
            :header-cell-style="{ background: '#F2F6FC' }"
            :data="entpList"
            ref="multipleTable"
            border
            style="width: 100%"
          >
            <el-table-column
              show-overflow-tooltip
              min-width="170px"
              prop="Cn"
              label="企业名称"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              min-width="200px"
              prop="LegalPerson"
              label="联系人"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              min-width="160px"
              prop="Email"
              label="邮箱"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              min-width="160px"
              prop="State"
              label="状态"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="100px">
              <template slot-scope="scope">
                <div class="ops-ctn">
                  <el-button
                    type="text"
                    size="mini"
                    title="发送邀请"
                    v-if="scope.row.IsCanApply"
                    @click="inviteMember(scope.row)"
                    >邀请加入联盟</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      entpName: "",
      entpList: [],
      isNonResult: true,
      unionId: this.$util.getLocalStorage("currentUnion"),
    };
  },
  mounted() {},
  methods: {
    getEntpData() {
      let that = this;
      that.loading = true;
      that.$util
        .axiosGet({
          url: "/api/EntpUnions/GetEntpDataList",
          data: {
            Key: that.entpName,
            UnionId: that.unionId,
          },
          hideLoading: true,
        })
        .then((res) => {
          if (res.data) {
            that.entpList = res.data;
            that.isNonResult = false;
          } else {
            that.$util.warningMsg("成功关联企业信息");
            that.isNonResult = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    inviteMember(item) {
      let that = this;
      this.$prompt("请填写邀请内容", "提示", {
        confirmButtonText: "发送邀请",
        cancelButtonText: "取消邀请",
        inputPattern: /^[\s\t\r\n]*\S+/,
        inputErrorMessage: "请填写邀请内容",
      })
        .then(({ value }) => {
          if (value) {
            that.loading = true;
            that.$util
              .axiosPost({
                url: "/api/EntpUnions/InviteEnterprise",
                data: {
                  EntpId: item.EntpId,
                  UnionId: that.unionId,
                  Message: value,
                },
                hideLoading: true,
              })
              .then(() => {
                that.$util.successMsg("成功发送邀请");
                that.getEntpData();
              })
              .finally(() => {
                that.loading = false;
              });
          } else that.$util.warningMsg("发送失败，请填写邀请内容");
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.searchtitle {
  font-size: 18px;
  font-weight: bold;
  margin-right: 5px;
}
.search-result {
  width: 900px;
  margin: 0 auto;
  padding-top: 30px;
}
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  min-height: 400px;
}
.containerBox {
  margin-top: 30px;
  // width: 1440px;
}
.search {
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.searchHistory {
  display: inline-flex;
  flex-flow: row-reverse;
}
.searchBox {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  .vin-input {
    width: 400px;
    padding-right: 5px;
  }
}
</style>